export default "<svg viewBox=\"0 0 12 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 5.056 5 9.5l6-8\"/></svg>"